import React from 'react';
import uuid from 'react-uuid';
import moment from 'moment';

import * as PageSettings from '../constants/pageSettings';
import * as fn from './_functions';
import * as ph from './personHelper';
import * as fm from './formatHelper';

export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LETTER_WIDTH = PageSettings.PAPER_LETTER_WIDTH;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LETTER_HEIGHT = PageSettings.PAPER_LETTER_HEIGHT;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_A4_WIDTH = PageSettings.PAPER_A4_WIDTH;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_A4_HEIGHT = PageSettings.PAPER_A4_HEIGHT;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LEGAL_WIDTH = PageSettings.PAPER_LEGAL_WIDTH;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LEGAL_HEIGHT = PageSettings.PAPER_LEGAL_HEIGHT;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_MARGINS_NARROW = PageSettings.MARGINS_NARROW;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_MARGINS_NORMAL = PageSettings.MARGINS_NORMAL;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_MARGINS_WIDE = PageSettings.MARGINS_WIDE;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_HEADER_FOOTER_HEIGHT_MIN = PageSettings.HEADER_FOOTER_HEIGHT_MIN;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_HEADER_FOOTER_HEIGHT_DEFAULT = PageSettings.HEADER_FOOTER_HEIGHT_DEFAULT;
export const MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_HEADER_FOOTER_HEIGHT_MAX = PageSettings.HEADER_FOOTER_HEIGHT_MAX;

export const MEDICAL_REPORT_TEMPLATE_CELL_WIDTH = 12.75;
export const MEDICAL_REPORT_TEMPLATE_ROW_HEIGHT = 5;

export const MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR = 'Richtext';
export const MEDICAL_REPORT_ELEMENT_IMAGE = 'Image';

export const MEDICAL_REPORT_ELEMENT_BUSINESS_NAME = 'BusinessName';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS = 'BusinessFullAddress';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1 = 'BusinessAddressLine1';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2 = 'BusinessAddressLine2';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY = 'BusinessAddressCountry';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE = 'BusinessPhone';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_FAX = 'BusinessFax';
export const MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL = 'BusinessEmail';

export const MEDICAL_REPORT_ELEMENT_PATIENT_NAME = 'PatientName';
export const MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS = 'PatientFullAddress';
export const MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1 = 'PatientAddressLine1';
export const MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2 = 'PatientAddressLine2';
export const MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY = 'PatientAddressCountry';
export const MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH = 'PatientDateOfBirth';
export const MEDICAL_REPORT_ELEMENT_PATIENT_PHONE = 'PatientPhone';
export const MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL = 'PatientEmail';
export const MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD = 'PatientHealthCard';

export const MEDICAL_REPORT_ELEMENT_EXAM_DATE = 'ExamDate';
export const MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR = 'ExamDoctor';
export const MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER = 'ExamDoctorLicenseNumber';
export const MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER = 'ExamDoctorBillingNumber';
export const MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE = 'ExamDoctorSignature';
export const MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE = 'RequesterSignature';
export const MEDICAL_REPORT_ELEMENT_EXAM_DATA = 'ExamData';

export const MEDICAL_REPORT_ELEMENT_SUBJECT = 'MedicalReportSubject';
export const MEDICAL_REPORT_ELEMENT_BODY = 'MedicalReportBody';
export const MEDICAL_REPORT_ELEMENT_PAGE_NUMBER = 'PageNumber';
export const MEDICAL_REPORT_ELEMENT_PRINTED_DATE = 'PrintedDate';

export const MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN = 'MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN';
export const MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN = 'MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN';
export const MEDICAL_REPORT_TEMPLATE_METADATA_PADDING = 'MEDICAL_REPORT_TEMPLATE_METADATA_PADDING';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR = 'MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE = 'MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY = 'MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FONT_STYLE = 'MEDICAL_REPORT_TEMPLATE_METADATA_FONT_STYLE';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FONT_LETTER_SPACING = 'MEDICAL_REPORT_TEMPLATE_METADATA_FONT_LETTER_SPACING';
export const MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR = 'MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR';
export const MEDICAL_REPORT_TEMPLATE_METADATA_BORDER = 'MEDICAL_REPORT_TEMPLATE_METADATA_BORDER';
export const MEDICAL_REPORT_TEMPLATE_METADATA_BORDER_COLOR = 'MEDICAL_REPORT_TEMPLATE_METADATA_BORDER_COLOR';
export const MEDICAL_REPORT_TEMPLATE_METADATA_ALTERNATE_BACKGROUND_COLOR = 'MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR';
export const MEDICAL_REPORT_TEMPLATE_METADATA_CONTENT = 'MEDICAL_REPORT_TEMPLATE_METADATA_CONTENT';
export const MEDICAL_REPORT_TEMPLATE_METADATA_IMAGE = 'MEDICAL_REPORT_TEMPLATE_METADATA_IMAGE';
export const MEDICAL_REPORT_TEMPLATE_METADATA_FORMAT = 'MEDICAL_REPORT_TEMPLATE_METADATA_FORMAT';
export const MEDICAL_REPORT_TEMPLATE_METADATA_EXAM_DATA = 'MEDICAL_REPORT_TEMPLATE_METADATA_EXAM_DATA';
export const MEDICAL_REPORT_TEMPLATE_METADATA_DOCTOR_SIGNATURE = 'MEDICAL_REPORT_TEMPLATE_METADATA_DOCTOR_SIGNATURE';

export const MedicalReportElementTypes = [
    MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR,
    MEDICAL_REPORT_ELEMENT_IMAGE,
    MEDICAL_REPORT_ELEMENT_BUSINESS_NAME,
    MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS,
    MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1,
    MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2,
    MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY,
    MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE,
    MEDICAL_REPORT_ELEMENT_BUSINESS_FAX,
    MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL,
    MEDICAL_REPORT_ELEMENT_PATIENT_NAME,
    MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS,
    MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1,
    MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2,
    MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY,
    MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH,
    MEDICAL_REPORT_ELEMENT_PATIENT_PHONE,
    MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL,
    MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD,
    MEDICAL_REPORT_ELEMENT_EXAM_DATE,
    MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR,
    MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER,
    MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER,
    MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE,
    MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE,
    MEDICAL_REPORT_ELEMENT_EXAM_DATA,
    MEDICAL_REPORT_ELEMENT_SUBJECT,
    MEDICAL_REPORT_ELEMENT_BODY,
    MEDICAL_REPORT_ELEMENT_PAGE_NUMBER,
    MEDICAL_REPORT_ELEMENT_PRINTED_DATE,
];

export const getPrintMessage = (name) => {
    return <>
        <h2 className='text-uppercase text-center font-weight-bold text-gray-900 mb-1'>Generating...</h2>
        <p className='fs-xl'>Please wait while we generate the medical report.</p>
    </>;
}

export const createElement = (type) => {
    return {
        id: uuid(),
        type: type,
        metadata: {},
        position: getDefaultPosition(type)
    };
}

export const isMedicalReportElement = ({ type }) => {
    return MedicalReportElementTypes.some(t => t === type);
}

export const hasField = (type, field) => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_PADDING,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_LETTER_SPACING,
                MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_CONTENT,
            ].some(f => f === field);

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_IMAGE,
            ].some(f => f === field);

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
        case MEDICAL_REPORT_ELEMENT_SUBJECT:
        case MEDICAL_REPORT_ELEMENT_BODY:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_PADDING,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_STYLE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_LETTER_SPACING,
                MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER_COLOR,
            ].some(f => f === field);

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_ALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_VALIGN,
                MEDICAL_REPORT_TEMPLATE_METADATA_PADDING,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_STYLE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_LETTER_SPACING,
                MEDICAL_REPORT_TEMPLATE_METADATA_BACKGROUND_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER,
                MEDICAL_REPORT_TEMPLATE_METADATA_BORDER_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_FORMAT,
            ].some(f => f === field);

        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_EXAM_DATA,
            ].some(f => f === field);

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
            return [
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_SIZE,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_FAMILY,
                MEDICAL_REPORT_TEMPLATE_METADATA_FONT_COLOR,
                MEDICAL_REPORT_TEMPLATE_METADATA_DOCTOR_SIGNATURE,
            ].some(f => f === field);

        default:
            return false;
    }
}

export const isPatientField = (type) => {
    return [
        MEDICAL_REPORT_ELEMENT_PATIENT_NAME,
        MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS,
        MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1,
        MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2,
        MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY,
        MEDICAL_REPORT_ELEMENT_PATIENT_PHONE,
        MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL,
        MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH,
        MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD,
    ].some(f => f === type);
}

export const isExamElement = (type) => {
    return [
        MEDICAL_REPORT_ELEMENT_EXAM_DATE,
        MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR,
        MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER,
        MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER,
        MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE,
        MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE,
        MEDICAL_REPORT_ELEMENT_EXAM_DATA,
    ].some(f => f === type);
}

export const getName = (type) => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return 'Richtext';

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return 'Image';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
            return 'BusinessName';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
            return 'BusinessFullAddress';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
            return 'BusinessAddressLine1';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
            return 'BusinessAddressLine2';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
            return 'BusinessAddressCountry';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
            return 'BusinessPhone';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
            return 'BusinessFax';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
            return 'BusinessEmail';

        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
            return 'PatientName';

        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
            return 'PatientFullAddress';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
            return 'PatientAddressLine1';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
            return 'PatientAddressLine2';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
            return 'PatientAddressCountry';

        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
            return 'PatientDateOfBirth';

        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
            return 'PatientPhone';

        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
            return 'PatientEmail';

        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
            return 'PatientHealthCard';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return 'ExamData';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
            return 'ExamDate';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
            return 'ExamDoctor';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
            return 'ExamDoctorLicenseNumber';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
            return 'ExamDoctorBillingNumber';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
            return 'ExamDoctorSignature';

        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
            return 'RequesterSignature';

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return 'MedicalReportSubject';

        case MEDICAL_REPORT_ELEMENT_BODY:
            return 'MedicalReportBody';

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return 'PageNumber';

        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return 'PrintedDate';

        default:
            return '';
    }
}

export const getDescription = (type) => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return 'Richtext';

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return 'Image';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
            return 'Business Name';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
            return 'Business Full Address';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
            return 'Business Address Line 1';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
            return 'Business Address Line 2';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
            return 'Business Address Country';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
            return 'Business Phone';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
            return 'Business Fax';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
            return 'Business Email';

        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
            return 'Patient Name';

        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
            return 'Patient Full Address';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
            return 'Patient Address Line 1';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
            return 'Patient Address Line 2';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
            return 'Patient Address Country';

        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
            return 'Patient Date of Birth';

        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
            return 'Patient Phone';

        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
            return 'Patient Email';

        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
            return 'Patient Health Card';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return 'Exam Data';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
            return 'Exam Date';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
            return 'Exam Doctor';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
            return 'Exam Doctor License Number';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
            return 'Exam Doctor Billing Number';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
            return 'Exam Doctor Signature';

        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
            return 'Requester Signature';

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return 'Subject';

        case MEDICAL_REPORT_ELEMENT_BODY:
            return 'Body';

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return 'Page Number';

        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return 'Printed Date';

        default:
            return '';
    }
}

export const getIcon = (type) => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return 'fal fa-text-size';

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return 'fal fa-image';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
            return 'fal fa-building';

        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
            return 'fal fa-user';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return 'fal fa-clipboard'

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return 'fal fa-external-link-square';

        case MEDICAL_REPORT_ELEMENT_BODY:
            return 'fal fa-external-link-square';

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return 'fal fa-hashtag'

        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return 'fal fa-calendar-alt'

        default:
            return '';
    }
}

export const getDefaultValue = (type, format) => {
    const formatOption = getFormatOptions(type).filter(f => f.type === format)[0];

    switch (type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return 'This is a sample text.';

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return '';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
            return 'Company Name';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
            return '199 Main Street East, Toronto, ON M1N 2N2, Canada';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
            return '199 Main Street East';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
            return 'Toronto, ON M1N 2N2';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
            return 'Canada';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
            return formatOption ? formatOption.example : '+14165559999';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
            return formatOption ? formatOption.example : '+14162223333';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
            return 'info@companyname.com';

        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
            return formatOption ? formatOption.example : 'Jonathan Williams';

        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
            return '355-20 Applegate Street, Toronto, ON M2M 3K3, Canada';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
            return '355-20 Applegate Street';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
            return 'Toronto, ON M2M 3K3';

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
            return 'Canada';

        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
            return 'July 1, 1980';

        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
            return formatOption ? formatOption.example : '+14166643333';

        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
            return 'jwilliams_20@patientemail.com';

        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
            return '1234-5678-910-AA';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
            return formatOption ? formatOption.example : moment().format('YYYY-MM-DD');

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
            return 'Dr. Sarah Williams';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
            return '0023456';

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
            return '0098765';

        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return '';

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return 'Subject of the MedicalReport';

        case MEDICAL_REPORT_ELEMENT_BODY:
            return 'This is the body of the medical report.';

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return formatOption ? formatOption.example : 'Page 1';

        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return formatOption ? formatOption.example : moment().format('YYYY-MM-DD');

        default:
            return '';
    }
}

export const getValue = (element, sources) => {
    const { type, metadata } = element;
    const { format } = metadata;
    const formatOptions = getFormatOptions(type);
    const formatOption = formatOptions.some(f => f.type === format) ? formatOptions.filter(f => f.type === format)[0] : { type: null };

    switch (type) {
        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
            return sources && sources.tenant ? fm.apply(sources.tenant.displayName, formatOption.type) : '';

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
            return sources && sources.tenant && sources.tenant.address && sources.tenant.address.fullLine ? fm.apply(sources.tenant.address.fullLine, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
            return sources && sources.tenant && sources.tenant.address && sources.tenant.address.addressLine1 ? fm.apply(sources.tenant.address.addressLine1, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
            return sources && sources.tenant && sources.tenant.address && sources.tenant.address.addressLine2 ? fm.apply(sources.tenant.address.addressLine2, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
            return sources && sources.tenant && sources.tenant.address && sources.tenant.address.country ? fm.apply(sources.tenant.address.country, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
            return sources && sources.tenant ? fm.apply(sources.tenant.phoneNumber, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
            return sources && sources.tenant ? fm.apply(sources.tenant.faxNumber, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
            return sources && sources.tenant ? fm.apply(sources.tenant.emailAddress, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
            return sources && sources.customer ? fm.apply(sources.customer, formatOption.type, ph.getPreferredFirstLastName(sources.customer)) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
            return sources && sources.customer && sources.customer && sources.customer.address && sources.customer.address.fullLine ? fm.apply(sources.customer.address.fullLine, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
            return sources && sources.customer && sources.customer && sources.customer.address && sources.customer.address.addressLine1 ? fm.apply(sources.customer.address.addressLine1, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
            return sources && sources.customer && sources.customer && sources.customer.address && sources.customer.address.addressLine2 ? fm.apply(sources.customer.address.addressLine2, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
            return sources && sources.customer && sources.customer && sources.customer.address && sources.customer.address.country ? fm.apply(sources.customer.address.country, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
            return sources && sources.customer ? fm.apply(sources.customer, formatOption.type, sources.customer.dateOfBirth) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
            return sources && sources.customer ? fm.apply(sources.customer.phoneNumber, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
            return sources && sources.customer ? fm.apply(sources.customer.emailAddress, formatOption.type) : null;

        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
            return sources && sources.customer && sources.customer.patientProfile ? ph.formatHealthCard(sources.customer.patientProfile.healthCardNumber) : null;

        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
            return sources && sources.exam && sources.exam.createdDateUtc ? fm.apply(moment.utc(sources.exam.createdDateUtc), formatOption.type, moment.utc(sources.exam.createdDateUtc).format('YYYY-MM-DD')) : null;

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
            return sources && sources.user ? fm.apply(sources.user, formatOption.type, ph.getPreferredFirstLastName(sources.user)) : null;

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
            return sources && sources.user ? sources.user.licenseNumber : null;

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
            return sources && sources.user ? sources.user.publicInsuranceProviderNumber : null;

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return sources && sources.subject ? sources.subject : null;

        case MEDICAL_REPORT_ELEMENT_BODY:
            return sources && sources.body ? sources.body : null;

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return formatOption ? formatOption.example : 'Page 1';

        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return fm.apply(moment(), formatOption.type, moment().format('YYYY-MM-DD'));

        default:
            return '';
    }
}

export const getFormatOptions = (type) => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
            return fm.NAME_FORMAT_OPTIONS;

        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
            return fm.PHONE_FORMAT_OPTIONS;

        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return fm.DATE_FORMAT_OPTIONS;

        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
            return fm.PAGE_NUMBER_FORMAT_OPTIONS;

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
            return fm.DOCTOR_NAME_FORMAT_OPTIONS;

        default:
            return [];
    }
}

export const renderElement = (element, options) => {
    const defaults = {
        controlKey: `_${uuid()}`,
        readOnly: null,
        isDesignMode: false,
        defaultValue: null,
        quickDrawer: null,
        value: null,
        onClick: null,
        onDoubleClick: null,
        onContextMenu: null,
    };
    options = { ...defaults, ...options }

    if (options.pageSettings) {
        options.pageSettings.paper = options.pageSettings.paper ? options.pageSettings.paper : getPaperDimension('letter');
        options.pageSettings.margins = options.pageSettings.margins ? options.pageSettings.margins : MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_MARGINS_NORMAL;
    } else {
        options.pageSettings = {
            paper: getPaperDimension('letter'),
            margins: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_MARGINS_NORMAL,
        };
    }

    switch (element.type) {
        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
        case MEDICAL_REPORT_ELEMENT_PAGE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
            return <div
                className={'form-group print-element no-label' + (element.metadata && element.metadata.valign && element.metadata.valign !== 'top' ? ` text-${element.metadata.valign}` : '')}
                style={{
                    borderTop: element.metadata && element.metadata.border && element.metadata.border.top ? element.metadata.border.top : 'none',
                    borderRight: element.metadata && element.metadata.border && element.metadata.border.right ? element.metadata.border.right : 'none',
                    borderBottom: element.metadata && element.metadata.border && element.metadata.border.bottom ? element.metadata.border.bottom : 'none',
                    borderLeft: element.metadata && element.metadata.border && element.metadata.border.left ? element.metadata.border.left : 'none',
                    backgroundColor: element.metadata && element.metadata.backgroundColor ? element.metadata.backgroundColor : 'transparent',
                }}
                data-id={element.id}
                onDoubleClick={options ? options.onDoubleClick : null}
                onContextMenu={options ? options.onContextMenu : null}
            >
                <div
                    data-key={`pe_${element.id}`}
                    className='element-wrapper'
                    style={{
                        lineHeight: 1.2,
                        textAlign: element.metadata && element.metadata.align ? element.metadata.align : 'left',
                        padding: element.metadata && element.metadata.padding && element.metadata.padding.length === 4 ? element.metadata.padding.map(p => { return `${p}px` }).join(' ') : null,
                        color: element.metadata && element.metadata.fontColor ? element.metadata.fontColor : null,
                        fontSize: element.metadata && element.metadata.fontSize ? `${element.metadata.fontSize}px` : null,
                        fontFamily: element.metadata && element.metadata.fontFamily ? element.metadata.fontFamily : null,
                        fontWeight: element.metadata && element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'bold') ? 'bold' : null,
                        fontStyle: element.metadata && element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'italic') ? 'italic' : null,
                        textDecoration: element.metadata && element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'underline') ? 'underline' : null,
                        letterSpacing: element.metadata && element.metadata.fontLetterSpacing ? `${element.metadata.fontLetterSpacing}px` : null,
                    }}
                >
                    {
                        element.type === MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR ?
                            <span dangerouslySetInnerHTML={{ __html: element.metadata.content }}></span> :
                            <span><p>{
                                options.defaultValue ?
                                    options.defaultValue :
                                    options.isDesignMode ? getDefaultValue(element.type, (element.metadata && element.metadata.format ? element.metadata.format : null)) : null
                            }</p></span>
                    }
                </div>
            </div>

        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return <div
                className={'form-group print-element no-label' + (element.metadata && element.metadata.valign && element.metadata.valign !== 'top' ? ` text-${element.metadata.valign}` : '')}
                data-id={element.id}
                onDoubleClick={options ? options.onDoubleClick : null}
                onContextMenu={options ? options.onContextMenu : null}
            >
                <div
                    data-key={`pe_${element.id}`}
                    className='element-wrapper'
                    style={{
                        textAlign: element.metadata && element.metadata.align ? element.metadata.align : 'left',
                    }}
                >
                    <img
                        src={`${(element.metadata && element.metadata.image ? element.metadata.image.base64 : null)}`}
                        style={{
                            width: (element.metadata && element.metadata.image ? getContainImage(element, options.pageSettings).width : null),
                            height: (element.metadata && element.metadata.image ? getContainImage(element, options.pageSettings).height : null),
                        }}
                        alt='print-element'
                    />
                </div>
            </div>

        case MEDICAL_REPORT_ELEMENT_SUBJECT:
        case MEDICAL_REPORT_ELEMENT_BODY:
            return <div
                className={'element-wrapper element-input h-100 no-label'}
                data-id={element.id}
            >
                <div
                    className={'form-group print-element no-label' + (element.metadata && element.metadata.valign && element.metadata.valign !== 'top' ? ` text-${element.metadata.valign}` : '')}
                    onDoubleClick={options.onDoubleClick}
                    onContextMenu={options.onContextMenu}
                >
                    <div className='element-wrapper'>
                        <div
                            id={options.inputKey}
                            className='html'
                            style={{
                                textAlign: element.metadata.align ? element.metadata.align : 'left',
                                color: element.metadata.fontColor ? element.metadata.fontColor : null,
                                fontSize: element.metadata.fontSize ? `${element.metadata.fontSize}px` : null,
                                fontFamily: element.metadata.fontFamily ? element.metadata.fontFamily : null,
                                fontWeight: element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'bold') ? 'bold' : null,
                                fontStyle: element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'italic') ? 'italic' : null,
                                textDecoration: element.metadata.fontStyle && element.metadata.fontStyle.some(s => s === 'underline') ? 'underline' : null,
                                letterSpacing: element.metadata.fontLetterSpacing ? `${element.metadata.fontLetterSpacing}px` : null,
                            }}
                            data-key={element.type}
                        >
                            {options.isDesignMode ? getDescription(element.type) : (options.value ? options.value : '')}
                        </div>
                    </div>
                </div>
            </div>

        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:  // Cannot be render on TemplateGrid
            const datasets = [{ label: 'Exam Label', definition: [''] }]
            const numberOfColumns = 1;

            return <div
                className={'element-wrapper element-input h-100 no-label'}
                data-id={element.id}
            >
                <div
                    className={'form-group print-element no-label'}
                    onDoubleClick={options.onDoubleClick}
                    onContextMenu={options.onContextMenu}
                >
                    <div className='control-wrapper justify-content-start'>
                        <table cellPadding={0} cellSpacing={0}>
                            <tbody>
                                {
                                    datasets.map((ds, dsi) => {
                                        return <tr key={`${element.key}_metadata_${dsi}`}>
                                            <td valign='top'>
                                                <div
                                                    style={{
                                                        textAlign: element.metadata && element.metadata.label && element.metadata.label.align ? element.metadata.label.align : 'left',
                                                        color: element.metadata && element.metadata.label && element.metadata.label.fontColor ? element.metadata.label.fontColor : null,
                                                        fontSize: element.metadata && element.metadata.label && element.metadata.label.fontSize ? `${element.metadata.label.fontSize}px` : null,
                                                        fontFamily: element.metadata && element.metadata.label && element.metadata.label.fontFamily ? element.metadata.label.fontFamily : null,
                                                        fontWeight: element.metadata && element.metadata.label && element.metadata.label.fontStyle && element.metadata.label.fontStyle.some(s => s === 'bold') ? 'bold' : null,
                                                        fontStyle: element.metadata && element.metadata.label && element.metadata.label.fontStyle && element.metadata.label.fontStyle.some(s => s === 'italic') ? 'italic' : null,
                                                        textDecoration: element.metadata && element.metadata.label && element.metadata.label.fontStyle && element.metadata.label.fontStyle.some(s => s === 'underline') ? 'underline' : null,
                                                        padding: '5px 10px 5px 0',
                                                        whiteSpace: 'nowrap',
                                                    }}
                                                >
                                                    {ds.label}
                                                </div>
                                            </td>
                                            {
                                                (() => {
                                                    const columns = [];

                                                    for (let ci = 0; ci < numberOfColumns; ci++) {
                                                        const columnValue = options.isDesignMode ? 'Exam Data' : (fn.isFunction(options.getExamDataValue) ? options.getExamDataValue(element.id, ds, ci) : '');

                                                        columns.push(<td
                                                            key={`${element.key}_metadata_column_${dsi}_${ci}`}
                                                            valign='top' style={{ width: `${100.0 / numberOfColumns}%` }}
                                                        >
                                                            <div
                                                                style={{
                                                                    textAlign: element.metadata && element.metadata.data && element.metadata.data.align ? element.metadata.data.align : 'left',
                                                                    color: element.metadata && element.metadata.data && element.metadata.data.fontColor ? element.metadata.data.fontColor : null,
                                                                    fontSize: element.metadata && element.metadata.data && element.metadata.data.fontSize ? `${element.metadata.data.fontSize}px` : null,
                                                                    fontFamily: element.metadata && element.metadata.data && element.metadata.data.fontFamily ? element.metadata.data.fontFamily : null,
                                                                    fontWeight: element.metadata && element.metadata.data && element.metadata.data.fontStyle && element.metadata.data.fontStyle.some(s => s === 'bold') ? 'bold' : null,
                                                                    fontStyle: element.metadata && element.metadata.data && element.metadata.data.fontStyle && element.metadata.data.fontStyle.some(s => s === 'italic') ? 'italic' : null,
                                                                    textDecoration: element.metadata && element.metadata.data && element.metadata.data.fontStyle && element.metadata.data.fontStyle.some(s => s === 'underline') ? 'underline' : null,
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                {columnValue}
                                                            </div>
                                                        </td>);
                                                    }

                                                    return columns;
                                                })()
                                            }
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
            return <div
                className={
                    'form-group print-element no-label' +
                    (element.metadata && element.metadata.hideReadonly === true && options.readOnly ? ' d-none' : '')
                }
                data-id={element.id}
            >
                <div
                    data-key={`pe_${element.id}`}
                    className='element-wrapper'
                >
                </div>
            </div>

        default:
            break;
    }
}

export const getDefaultPosition = type => {
    switch (type) {
        case MEDICAL_REPORT_ELEMENT_IMAGE:
            return { w: 10, h: 10, minW: 1 };

        case MEDICAL_REPORT_ELEMENT_RICHTEXT_EDITOR:
            return { w: 20, h: 10, minW: 2 };

        case MEDICAL_REPORT_ELEMENT_BUSINESS_NAME:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_PHONE:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_FAX:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_NAME:
        case MEDICAL_REPORT_ELEMENT_PATIENT_DATE_OF_BIRTH:
        case MEDICAL_REPORT_ELEMENT_PATIENT_PHONE:
        case MEDICAL_REPORT_ELEMENT_PATIENT_EMAIL:
        case MEDICAL_REPORT_ELEMENT_PATIENT_HEALTH_CARD:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATE:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_LICENSE_NUMBER:
        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_BILLING_NUMBER:
        case MEDICAL_REPORT_ELEMENT_PRINTED_DATE:
        case MEDICAL_REPORT_ELEMENT_SUBJECT:
            return { w: 6, h: 4, minW: 2 };

        case MEDICAL_REPORT_ELEMENT_BUSINESS_FULL_ADDRESS:
        case MEDICAL_REPORT_ELEMENT_PATIENT_FULL_ADDRESS:
            return { w: 20, h: 10, minW: 2 };

        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_BUSINESS_ADDRESS_COUNTRY:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE1:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_LINE2:
        case MEDICAL_REPORT_ELEMENT_PATIENT_ADDRESS_COUNTRY:
            return { w: 12, h: 4, minW: 2 };

        case MEDICAL_REPORT_ELEMENT_BODY:
        case MEDICAL_REPORT_ELEMENT_EXAM_DATA:
            return { w: 40, h: 10, minW: 40, maxH: 20 };

        case MEDICAL_REPORT_ELEMENT_EXAM_DOCTOR_SIGNATURE:
        case MEDICAL_REPORT_ELEMENT_REQUESTER_SIGNATURE:
            return { w: 33, h: 10, minW: 15 };

        default:
            return {};
    }
}

export const getContainImage = (imageElement, pageSettings) => {
    let { width: imageWidth, height: imageHeight } = imageElement.metadata.image;
    const containerWidth = parseFloat(imageElement.position.w * ((pageSettings.paper.width - (pageSettings.margins * 2)) / 64), 10);
    const containerHeight = parseFloat(imageElement.position.h * MEDICAL_REPORT_TEMPLATE_ROW_HEIGHT, 10);

    if (containerHeight >= containerWidth) {
        if (imageHeight > containerHeight) {
            const heightScale = containerHeight / imageHeight;

            imageWidth = imageWidth * heightScale;
            imageHeight = containerHeight;
        }

        if (imageWidth > containerWidth) {
            const scale = containerWidth / imageWidth;

            imageWidth = containerWidth;
            imageHeight = imageHeight * scale;
        }
    }
    else if (containerWidth > containerHeight) {
        if (imageWidth > containerWidth) {
            const widthScale = containerWidth / imageWidth;

            imageWidth = containerWidth;
            imageHeight = imageHeight * widthScale;
        }

        if (imageHeight > containerHeight) {
            const scale = containerHeight / imageHeight;

            imageWidth = imageWidth * scale;
            imageHeight = containerHeight;
        }
    }

    return {
        width: imageWidth,
        height: imageHeight,
    };
}

export const getPaperDimension = (paperType) => {
    if (!paperType) {
        paperType = 'letter';
    }

    switch (paperType.toLowerCase()) {
        case 'a4':
            return {
                type: paperType.toLowerCase(),
                width: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_A4_WIDTH,
                height: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_A4_HEIGHT,
            };

        case 'legal':
            return {
                type: paperType.toLowerCase(),
                width: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LEGAL_WIDTH,
                height: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LEGAL_HEIGHT,
            };

        case 'letter':
        default:
            return {
                type: paperType.toLowerCase(),
                width: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LETTER_WIDTH,
                height: MEDICAL_REPORT_TEMPLATE_PAGE_SETTINGS_PAPER_LETTER_HEIGHT,
            };
    }
}

export const getTextAreaRows = (value) => {
    const numberOfReturns = value ? (value.match(/\n/g) || []).length : 0;
    return (numberOfReturns + 1);
}